import script from "./RecChannels.vue?vue&type=script&setup=true&lang=js"
export * from "./RecChannels.vue?vue&type=script&setup=true&lang=js"

import "./RecChannels.vue?vue&type=style&index=0&id=7c87f5bc&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c87f5bc"]])

export default __exports__